export default "__VITE_ASSET__38bbb41d__"